export default "__VITE_ASSET__73d926e1__"